/* eslint-disable react/prop-types */
import React from 'react';

// A lightweight image renderer for chart bytes that centers the image inside the tile body
const SimpleChartImage = ({
  imageContent,
  imageType = 'image/png',
  alt = 'Chart',
  height = 220 // default a compact height; can be overridden per tile
}) => {
  if (!imageContent)
    return <div className="k-text-secondary">No chart image</div>;

  const src = imageContent.startsWith('data:')
    ? imageContent
    : `data:${imageType};base64,${imageContent}`;

  return (
    <div
      className="k-p-2"
      style={{
        width: '100%',
        height, // fixed compact height by default
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden'
      }}
    >
      <img
        src={src}
        alt={alt}
        style={{
          maxWidth: '100%',
          maxHeight: '100%',
          objectFit: 'contain',
          display: 'block'
        }}
      />
    </div>
  );
};

export default SimpleChartImage;
